import React, { useEffect, useState } from 'react';

const CHECK_INTERVAL = 60 * 1000; // Check every 1 minute

const VersionCheck = () => {
    const [hasUpdate, setHasUpdate] = useState(false);

    useEffect(() => {
        let currentVersionTimestamp = null;

        const checkVersion = async () => {
            try {
                // Add timestamp to prevent caching of version.json itself
                const response = await fetch(`/version.json?t=${Date.now()}`);
                if (!response.ok) return;

                const data = await response.json();

                // Initialize current version on first load
                if (!currentVersionTimestamp) {
                    currentVersionTimestamp = data.timestamp;
                    return;
                }

                // Check if timestamp has changed
                if (data.timestamp > currentVersionTimestamp) {
                    setHasUpdate(true);
                }
            } catch (error) {
                console.error('Error checking version:', error);
            }
        };

        // Check immediately on mount
        checkVersion();

        // Set up interval
        const intervalId = setInterval(checkVersion, CHECK_INTERVAL);

        // Also check when window gains focus
        const onFocus = () => checkVersion();
        window.addEventListener('focus', onFocus);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('focus', onFocus);
        };
    }, []);

    const handleRefresh = () => {
        window.location.reload(true);
    };

    if (!hasUpdate) return null;

    return (
        <div className="fixed bottom-4 left-4 z-[9999] animate-bounce-in">
            <div className="bg-indigo-600 text-white px-6 py-4 rounded-lg shadow-2xl flex items-center gap-4 border border-indigo-400">
                <div>
                    <h3 className="font-bold text-lg">มีการอัปเดตใหม่! 🚀</h3>
                    <p className="text-indigo-100 text-sm">กรุณารีเฟรชเพื่อใช้งานเวอร์ชั่นล่าสุด</p>
                </div>
                <button
                    onClick={handleRefresh}
                    className="bg-white text-indigo-600 px-4 py-2 rounded-md font-bold hover:bg-indigo-50 transition-colors shadow-sm whitespace-nowrap"
                >
                    รีเฟรชทันที
                </button>
            </div>
        </div>
    );
};

export default VersionCheck;
